import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";

const Holiday = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Holiday"));
  }, []);

  const [holiday, setHoliday] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [holidayID, setHolidayId] = useState("");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Description: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  useEffect(() => {
    fetchHoliday();
  }, [searchTerm]);

  const fetchHoliday = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}holidaymaster`);
      SetApiStatus(response?.status);
      setHoliday(response?.data?.data);
    } catch (error) {
      console.error("Error fetching holiday:", error);
    }
  };

  useEffect(() => {
    if (holidayID != "") {
      fetchHolidayID(holidayID);
    }
  }, [holidayID]);

  const fetchHolidayID = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}holidaymaster/${id}`);

      if (response.status === 200) {
        const formDataEdit = response?.data?.data;

        if (formDataEdit) {
          const { ID, Name, Code, Description } = formDataEdit;

          setFormData({
            ID: ID,
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
          });
        } else {
          console.error("PR Ques Master not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch PR Ques Master details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching holiday:", error);
    }
  };

  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Holiday", align: "start", visible: true },
    Description: { text: "Description", align: "center", visible: true },
  };

  const defaultColumns = {
    Code: true,
    Name: true,
    Description: true,
  };

  const handleEdit = async (id) => {
    setShowModal(true);
    setHolidayId(id.ID);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Description: "",
    });

    setErrors({});
    setInputDisabled(false);
    setShowSubmitButton(true);
  };

  const schema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    Code: Yup.string().required("Code is required"),
  });

  // Validate individual fields
  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));
      }
    }
  };
  // Handle dropdown change
  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Always update the form data
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Only validate if the field exists in the schema
      if (schema.fields[name]) {
        validateField(name, updatedData);
      }

      return updatedData;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      // Validate the entire form data
      await schema.validate(formData, { abortEarly: false });
      setErrors((prev) => ({
        ...prev,
      }));

      const url = formData.ID
        ? `${API_URL}holidaymaster/${formData.ID}`
        : `${API_URL}holidaymaster`;

      const method = formData.ID ? "put" : "post";
      const response = await PostServiceCaller(url, { ...formData }, method);
      if (response.status === 200) {
        toast.success(
          formData.ID
            ? "Holiday data updated successfully!"
            : "Holiday data submitted successfully!"
        );
        setShowModal(false);
        fetchHoliday();
        resetFormState();
      } else {
        console.error(`Failed to submit data. Status: ${response.status}`);
        toast.error("An error occurred while submitting the data.");
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      if (error instanceof Yup.ValidationError) {
        setErrors(
          error.inner.reduce(
            (acc, err) => ({ ...acc, [err.path]: err.message }),
            {}
          )
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
  };

  const handleAddForm = () => {
    resetFormState();
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={holiday}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isActionRequired={true}
              showIcon2={false}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              showIcon3={false}
              isSorting={true}
              showIcon4={true}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddForm}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
              }}
            />
          </div>
          <div>
            {showModal && (
              <div
                className="modal "
                tabIndex="-1"
                role="dialog"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div
                      className="modal-header d-flex justify-content-between"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #f0f0f0",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px 8px 0 0",
                        padding: "12px 16px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#27568B",
                          margin: "0",
                        }}
                      >
                        {formData.ID ? "Edit Holiday" : "Add New Holiday"}
                      </p>
                      <span className="me-2">
                        <i
                          className="bi bi-x-lg"
                          onClick={handleEditModalClose}
                        ></i>
                      </span>
                    </div>
                    <div className="modal-body">
                      <div className="">
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <label htmlFor="Code" className="col-form-label">
                                <strong>
                                  Code<span className="required">*</span>
                                </strong>
                              </label>
                              <input
                                type="text"
                                id="Code"
                                name="Code"
                                className={`form-control ${
                                  errors.Code ? "is-invalid" : ""
                                }`}
                                value={formData.Code}
                                onChange={(e) => handleChange(e)}
                                aria-describedby="Code"
                                disabled={inputDisabled}
                              />
                              {errors.Code && (
                                <div className="invalid-feedback">
                                  {errors.Code}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-2">
                              <label htmlFor="Name" className="col-form-label">
                                <strong>
                                  Name<span className="required">*</span>
                                </strong>
                              </label>

                              <input
                                type="text"
                                id="Name"
                                name="Name"
                                className={`form-control ${
                                  errors.Name ? "is-invalid" : ""
                                }`}
                                value={formData.Name}
                                onChange={(e) => handleChange(e)}
                                aria-describedby="Name"
                                disabled={inputDisabled}
                              />
                              {errors.Name && (
                                <div className="invalid-feedback">
                                  {errors.Name}
                                </div>
                              )}
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label
                                  htmlFor="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Description
                                </label>
                                <textarea
                                  className={`form-control ${
                                    errors.Description ? "is-invalid" : ""
                                  }`}
                                  id="Description" // Changed from exampleFormControlTextarea1 to match the name
                                  rows="3"
                                  name="Description"
                                  value={formData.Description || ""} // Ensure fallback for undefined
                                  onChange={handleChange}
                                ></textarea>
                                {errors.Description && (
                                  <div className="invalid-feedback">
                                    {errors.Description}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="text-end">
                            <button
                              className="cancel-btn me-2"
                              onClick={handleEditModalClose}
                            >
                              Cancel
                            </button>
                            {showSubmitButton && (
                              <button
                                type="submit"
                                disabled={loading ? true : false}
                                className="custom-btn me-2"
                              >
                                {loading ? (
                                  <FaSpinner class="sm-spinner" />
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Holiday;
